export default "28ce7792741e944eb52b8f019581eb4b.svg";